import { HeadingLevel, Icon, Heading, Tag, Text } from '@zapier/design-system';
import React from 'react';
import { PageHeaderBase } from './PageHeaderBase.es.js';

const headerWrapper = "_header-wrapper_10gs3_1";
const titleRow = "_title-row_10gs3_7";
const titleContent = "_title-content_10gs3_8";
const pageIcon = "_page-icon_10gs3_18";
const title = "_title_10gs3_7";
const pageTag = "_page-tag_10gs3_40";
const responsiveTag = "_responsive-tag_10gs3_45";
const actionsContainer = "_actions-container_10gs3_51";
const defaultActions = "_default-actions_10gs3_59";
const compactActions = "_compact-actions_10gs3_63";
const additionalContent = "_additional-content_10gs3_82";
const styles = {
	headerWrapper: headerWrapper,
	titleRow: titleRow,
	titleContent: titleContent,
	pageIcon: pageIcon,
	title: title,
	pageTag: pageTag,
	responsiveTag: responsiveTag,
	actionsContainer: actionsContainer,
	defaultActions: defaultActions,
	compactActions: compactActions,
	additionalContent: additionalContent
};

const PageHeader = ({ breadcrumbs, title, actions, compactActions, description, additionalContent, pageIcon, pageTag, pageIconColor = "inherit" }) => {
  return React.createElement(
    PageHeaderBase,
    { topRowContent: breadcrumbs },
    React.createElement(
      "header",
      { className: styles.headerWrapper, "data-zds": true },
      React.createElement(
        "div",
        { className: styles.titleRow },
        React.createElement(
          HeadingLevel,
          null,
          React.createElement(
            "div",
            { className: styles.titleContent },
            pageIcon && React.createElement("div", { className: styles.pageIcon, style: { fill: pageIconColor }, "data-zds": true }, typeof pageIcon === "string" ? React.createElement(Icon, { color: "inherit", size: "var(--page-icon-size)", name: pageIcon }) : pageIcon),
            React.createElement(Heading, { className: styles.title }, title),
            pageTag && React.createElement("div", { className: styles.pageTag, "data-zds": true }, typeof pageTag === "string" ? React.createElement(Tag, { variant: "simple", size: "x-small", className: styles.responsiveTag }, pageTag) : pageTag)
          )
        ),
        (actions !== null && actions !== void 0 ? actions : compactActions) && React.createElement(
          "div",
          { className: styles.actionsContainer, "data-zds": true },
          compactActions && React.createElement("div", { className: styles.compactActions }, compactActions),
          actions && React.createElement("div", { className: styles.defaultActions }, actions)
        )
      ),
      description && React.createElement(Text, { tag: "p", type: "Body1Multiline", color: "GrayWarm9", style: { padding: "var(--zds-space-8) 0" } }, description)
    ),
    additionalContent && React.createElement("div", { className: styles.additionalContent, "data-zds": true }, additionalContent)
  );
};

export { PageHeader };
//# sourceMappingURL=PageHeader.es.js.map
